import React from 'react';
import createHistory from 'history/createHashHistory';
const history = createHistory();
import NHFetch from "@utils/NHFetch";
/*页面*/
import SiderMenu from '@pages/Assembly/siderMenu';
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import Flex from "@components/Flex";
import './index.css';
export default class Route extends React.Component {

    constructor(props) {
        super(props);
        this.state={
        }
    }

    componentWillMount(){
        this.loadMenuList();
        this.getBddCssz();
    }

    loadMenuList=()=>{
        NHFetch('/zzbd/getZzbdInfoList','GET').then(resData => {
            if (resData && resData.data) {
                this.toLink(resData.data);
            }
        });
    }

    //获取报到单学校模板参数设置
    getBddCssz = () => {
        NHFetch('/zzbdCommon/getCssz', 'GET', { csbz: 'YXXT_BDD_SCHOOL' }).then(res => {
            if (res ) {
                if(res.data){
                    console.log('res.data', res.data)
                    this.setState({ bddSchool: res.data });
                }else{
                    this.setState({ bddSchool: 'lydx' });
                }
            }else{
                this.setState({ bddSchool: 'lydx' });
            }
        })
    }

    toLink=(menuList)=>{
        if(menuList && menuList.length>0){
            let menu = menuList[0];
            let hjdm = menu.HJDM;
            let pkid = menu.PKID;
            let lx = menu.LX;
            let {bddSchool} = this.state;
            if(hjdm.indexOf('GD')==0){
                let hashUrl = hjdm === 'GD009' ? '/' + bddSchool + 'Index' : mkbz[hjdm];
                history.push({
                        pathname:hashUrl,
                        search:'pkid='+pkid,
                    }
                );
            }else if(hjdm.indexOf('ZDY')==0){
                let hashUrl = '/customLink';
                history.push({
                        pathname:hashUrl,
                        search:'pkid='+pkid+'&mkbz='+hjdm+'&lx='+lx,
                    }
                );
            }
        }
    }

    render() {
        return (
            <div styleName="page_pay">
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu
                            title="自助报到"
                            menuType='自助报到'
                        />
                        <Flex.Item className="page_con_r">
                            <Breadcrumb
                                noLine
                                list={[
                                    { name: '首页', url: '/index' },
                                    { name: '自助报到', url: '/register' },
                                ]}
                            />

                        </Flex.Item>
                    </Flex>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/pages/SelfHelp/route/index.js